export default {
  OPEN_GRAPH: {
    TYPE: 'website',
    FB_APP_ID: '1144452742257762',
    COVER_SIZE: {
      VOD: {
        WIDE: {
          ID: 'BANNER_1',
          WIDTH: '700',
          HEIGHT: '394'
        }
      },
      LIVE: {
        WIDE: {
          ID: 'RATIO_16_9',
          WIDTH: '700',
          HEIGHT: '394'
        },
        STANDARD: {
          ID: 'RATIO_4_3',
          WIDTH: '352',
          HEIGHT: '272'
        }
      }
    },
    DEFAULT: {
      LOCALE: 'fr_FR',
      COVER: '/images/og-tc-default.jpg',
      VOD: {
        BASEURL: 'video-à-la-demande.orange.fr',
        TITLE: 'VOD ORANGE - Vidéo à la demande',
        DESCRIPTION: 'Vos films préférés en VOD avec Orange',
      },
      LIVE: {
        BASEURL: 'chaines-tv.orange.fr',
        TITLE: 'Programmes TV ORANGE',
        DESCRIPTION: `TV en direct et en replay où et quand vous le voulez`
      }
    }
  },
  TWITTER: {
    DEFAULT: {
      VOD: {
        BASEURL: 'video-à-la-demande.orange.fr',
        TITLE: 'VOD ORANGE - Vidéo à la demande',
        DESCRIPTION: `Plus de 20 000 vidéos disponibles en location ou à l&#39;achat : nouveautés films, séries récentes. Visionnage en ligne ou téléchargement, sur PC, MAC, smartphone, tablette et sur la TV Orange`
      },
      LIVE: {
        BASEURL: 'chaines-tv.orange.fr',
        TITLE: 'Programmes TV ORANGE',
        DESCRIPTION: `TV en direct et en replay où et quand vous le voulez`
      },
      COVER: '/images/og-tc-default.jpg',
    },
    CARD: 'summary_large_image',
    SITE: '@tvorange'
  }
}
